import { useEffect, useRef } from "react";

const useScrollToTopOnNavigation = (location, domNode = document.scrollingElement) => {
	const scrollContainer = useRef(domNode);
	const currentPath = location.pathname;
	useEffect(() => {
		if (!scrollContainer.current) {
			return;
		}

		// No scrollTo support.
		if (!scrollContainer.current.scrollTo) {
			scrollContainer.current.scrollTop = 0;

			return;
		}

		scrollContainer.current.scrollTo(0, 0);
	}, [currentPath]);

	return scrollContainer;
};

export default useScrollToTopOnNavigation;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useScrollToTopOnNavigation.js